import * as React from "react";
import Svg, { SvgProps, Path } from "react-native-svg";
const SvgComponent = (props: SvgProps) => (
  <Svg width={20} height={20} fill="none" {...props}>
    <Path
      fill="#000"
      d="M4.727 16.551c-.358 0-.66-.123-.907-.37a1.234 1.234 0 0 1-.371-.908V4.727c0-.358.123-.66.37-.907.248-.248.55-.371.908-.371h10.546c.358 0 .66.123.907.37.248.248.371.55.371.908v10.546c0 .358-.123.66-.37.907-.248.248-.55.371-.908.371H4.727Zm.004-.769h10.538a.49.49 0 0 0 .353-.16.49.49 0 0 0 .16-.353V4.731a.49.49 0 0 0-.16-.353.49.49 0 0 0-.353-.16H4.731a.49.49 0 0 0-.353.16.49.49 0 0 0-.16.353v10.538a.49.49 0 0 0 .16.353.49.49 0 0 0 .353.16Z"
    />
    <Path
      fill="#000"
      d="M10 9.74c-.343 0-.63-.116-.864-.35a1.174 1.174 0 0 1-.35-.864c0-.17.03-.326.09-.468a.97.97 0 0 1 .27-.368c.203-.21.658-.48 1.365-.81.706-.33 1.378-.624 2.016-.88-.262.6-.556 1.262-.884 1.988-.328.725-.597 1.19-.806 1.393a.97.97 0 0 1-.368.27c-.142.06-.298.09-.469.09Z"
    />
  </Svg>
);
export default SvgComponent;
